import React from 'react'

// Opening the search modal is shell-level state, triggered from several places
// (the sidebar row, the home hero, ⌘K). Exposed via context so descendants
// reach it without threading a callback through every page.
const HelpSearchContext = React.createContext<() => void>(() => {})

export const HelpSearchProvider = HelpSearchContext.Provider

export function useHelpSearch(): () => void {
  return React.useContext(HelpSearchContext)
}
